import React from "react";
import { Progress, Space } from "antd";
const LoadingProgress = props => {
  const { percent, status } = props;
  return (
    <Space
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
      }}
    >
      <Progress type="circle" percent={percent} status={status} />
    </Space>
  );
};

export default LoadingProgress;
